// extracted by mini-css-extract-plugin
module.exports = {"pageSection_container":"PageSection_pageSection_container__qffLj","pageSection_fullHeight":"PageSection_pageSection_fullHeight__056Vh"};